import { createLazyComponent, type LazyComponent } from "owa-bundling";
import { lazyModule } from "./lazyFunctions";
import type { SearchHeaderProps } from "./components/SearchHeader";

// Export components
export const SearchHeader: LazyComponent<SearchHeaderProps, unknown, void> = createLazyComponent(lazyModule, m => m.SearchHeader);

// Export store stuff
export type { default as MailSearchStore } from "./store/schema/MailSearchStore";
export type { PeopleRefinerSelection } from "./store/schema/PeopleRefinerSelection";
export { default as mailSearchStore, getStore } from "./store/store";
export { addFromRefinerSelectionMutator, removeFromRefinerSelectionMutator, } from "./mutatorActions/fromRefinerSelectionMutators";
export { addToRefinerSelectionMutator, removeToRefinerSelectionMutator, } from "./mutatorActions/toRefinerSelectionMutators";

// Export actions
export { clearSearchScope, setStaticSearchScope, onFolderScopeUpdate, loadTableViewFromSearchTableQuery, type LOAD_TABLE_VIEW_FROM_SEARCH_TABLE_QUERYActionMessage, } from "./actions/publicActions";

// Export selectors
export { default as isSearchRefinerApplied } from "./selectors/isSearchRefinerApplied";
export { default as getCountOfHiddenTopResults } from "./selectors/getCountOfHiddenTopResults";
export { default as getFromRefinerSelections } from "./selectors/getFromRefinerSelections";
export { default as getToRefinerSelections } from "./selectors/getToRefinerSelections";
export { SearchHeaderFirstRowContent, 
// eslint-disable-next-line owa-custom-rules/no-import-export -- temporary solution for no needing to export the module to setupMailModuleCommonPostRender
lazyModule, lazySetStaticSearchScopeData, lazyStartSearchWithCategory, lazyFindEmailFromSender, lazyFindEmailFromConversation, lazyInitializeSearch, lazyGetSubstrateSuggestions, LazySearchHeader, lazySelectSearchSortOrder, } from "./lazyFunctions";
export { default as getIsSubfolderScope } from "./selectors/getIsSubfolderScope";
export { default as getIsAllMailboxesScopeSelected } from "./selectors/getIsAllMailboxesScopeSelected";
export { default as getIsAggregateMailboxScopeSelected } from "./selectors/getIsAggregateMailboxScopeSelected";
export { default as prepareFolderForestForSearch } from "./mutators/prepareFolderForestForSearch";
export { default as shouldInitializeSearch } from "./utils/shouldInitializeSearch";
export { default as trackSearchEndToEndDatapoint } from "./utils/trackSearchEndToEndDatapoint";
export { default as isOriginalGenWebQueryOnTypeExperienceEnabled } from "./utils/isOriginalGenWebQueryOnTypeExperienceEnabled";
